import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./link.html";
import { getObjectAttr } from '../common/common';
export let LinkUnderline = /*#__PURE__*/function (LinkUnderline) {
  LinkUnderline["None"] = "none";
  LinkUnderline["Hover"] = "hover";
  LinkUnderline["Always"] = "always";
  return LinkUnderline;
}({});
class Link extends LightningElement {
  constructor(...args) {
    super(...args);
    this._underline = LinkUnderline.Hover;
    this.callToAction = {};
    this.slotsClasses = {};
  }
  set props(value) {
    const props = getObjectAttr(value);
    if (props) {
      if (props.callToAction) {
        this.callToAction = props.callToAction;
      }
      if (props.color) {
        this._color = props.color;
      }
      if (props.underline) {
        this._underline = props.underline;
      }
      this.updateStyleProperties();
    }
  }
  get props() {
    return {
      color: this.color,
      underline: this.underline,
      callToAction: this.callToAction
    };
  }
  set href(value) {
    this.callToAction.url = value;
  }
  get href() {
    return this.callToAction.url ?? '#';
  }
  set name(value) {
    this.callToAction.name = value;
  }
  get name() {
    return this.callToAction.name ?? this.label;
  }
  set label(value) {
    this.callToAction.label = value;
  }
  get label() {
    return this.callToAction.label ?? '';
  }
  handleSlotChange(event) {
    const slot = event.target;
    const nodes = slot.assignedNodes();
    if (nodes) {
      this.slotsClasses[slot.name] = nodes.length !== 0 ? slot.name : 'none';
    }
    if (!slot.name && nodes && nodes.length !== 0) {
      // If slot default has text will set in the label props of the CallToAction
      this.callToAction.label = nodes[0].textContent || undefined;
    }
  }
  set color(value) {
    this._color = value;
    this.updateStyleProperties();
  }
  get color() {
    return this._color;
  }
  set underline(value) {
    this._underline = value;
    this.updateStyleProperties();
  }
  get underline() {
    return this._underline;
  }

  // Need to take out this logic from the setters when we implemented the props pattern
  updateStyleProperties() {
    this.template.host.style.setProperty('--ads-link-color', this._color);
    if (this._underline === LinkUnderline.Hover) {
      this.template.host.style.setProperty('--ads-link-text-decoration', 'none');
      this.template.host.style.setProperty('--ads-link-text-decoration-hover', 'underline');
    } else {
      this.template.host.style.setProperty('--ads-link-text-decoration', this._underline);
      this.template.host.style.setProperty('--ads-link-text-decoration-hover', this._underline);
    }
  }
  handleAnalytics(event) {
    event.detail.link = this.props;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Link, {
  publicProps: {
    props: {
      config: 3
    },
    href: {
      config: 3
    },
    name: {
      config: 3
    },
    label: {
      config: 3
    },
    color: {
      config: 3
    },
    underline: {
      config: 3
    }
  },
  track: {
    callToAction: 1,
    slotsClasses: 1
  },
  fields: ["_underline"]
});
const __lwc_component_class_internal = _registerComponent(Link, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;